<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { hideAll } from 'tippy.js';
import { isEmpty, isNil } from 'lodash';
import UpdateHotelSettingsMixin from '../../../mixins/UpdateHotelSettingsMixin';

export default {
  name: 'LoadingWrapper',

  mixins: [HotelmeisterMixin, UpdateHotelSettingsMixin],

  computed: {
  },

  mounted: function () {
    this.$el.addEventListener('scroll', () => {
      hideAll({ duration: 0 });
    });
  },

  methods: {
    env: function (name) {
      return process.env[name];
    },
  },

  render: function (h) {
    return h(
      'div',
      { class: 'loading-wrapper' },
      [
        this.settingsFullyLoaded ? this.$slots.default : h('main', { class: 'main main--full' }, [('hm-col', { cols: 12 }, [h('div', { class: 'logo-wrapper' }, [h('div', { class: `logo-inner logo-inner--${this.env('WHITE_LABEL_KEY')}` })])])]),
      ],
    );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .loading-wrapper {
    overflow-x: hidden;
    overflow-y: auto;

    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: "main";

    z-index: 48;
  }

  .logo-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 56px;
    width: 56px;
  }

  .logo-inner {
    width: 100%;
    height: 100%;
    background-image: url('~svg/hotelmeister-icon.svg');
    background-position: left center;
    background-repeat: no-repeat;
    background-size: cover;
    animation: preloader 2.8s infinite ease-in-out;

    @include whitelabel-class() {
      background-image: url('~svg/#{$whitelabelKey}-icon.svg');
    }
  }

  @keyframes preloader {
    0% {
      transform: perspective(117px) rotateX(0deg) rotateY(0deg);
    }
    25% {
      transform: perspective(117px) rotateX(-180.1deg) rotateY(0deg);
    }
    50% {
      transform: perspective(117px) rotateX(-180deg) rotateY(-179.9deg);
    }
    75% {
      transform: perspective(117px) rotateX(-180.1deg) rotateY(0deg);
    }
    100% {
      transform: perspective(117px) rotateX(0deg) rotateY(0deg);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/lib/util/LoadingWrapper.vue